/* SIMOTEK — shared helpers used across theme.js, shipping-fee.js, delivery-rates.js,
   product-finder.js and main-wishlist.liquid. Load this before those scripts. */
window.SimotekUtils = (() => {
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[char]));

  const safeURL = (value = '') => {
    try {
      const url = new URL(String(value), window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return '#';
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.href;
    } catch (_) {
      return '#';
    }
  };

  const normalizeCity = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['’]/g, ' ')
    .replace(/[-_/]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return { escapeHTML, safeURL, normalizeCity };
})();
